import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button, Tree } from "@/comn/components";
import {
    useForm,
    useFetch,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useTheme,
    useModal,
    useTree,
    useResource,
} from "@/comn/hooks";
import { BASE, APIS, SF_ORGZ_SRCH, SF_ORGZ_INFO } from "./services/ComnCdService";

export const OrgzUsrRgsrLst = (props: any) => {
    const pgeUid = "orgzUsrRgsrLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const tree = useTree(); // Tree Hook !== Tree Hook ==!
    const { theme } = useTheme();
    const params = props.params;

    const langCd = theme.lang.toUpperCase();

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0021" }, { area: "orgzUsrRgsr" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Organizations List Search !== 조직 목록 검색 ==!
        orgzListSrch: useForm({
            defaultSchema: SF_ORGZ_SRCH,
            // defaultValues: { ...pgeStore?.form, langCd: langCd || "", uprOrgzSrchYn: params?.uprOrgzSrchYn } || {},
            defaultValues: { langCd: langCd || "", uprOrgzSrchYn: params?.uprOrgzSrchYn } || {},
        }),

        // Organizations Info !== 조직 상세 ==!
        orgzInfo: useForm({
            defaultSchema: SF_ORGZ_INFO,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Organazations List !==  조직 목록 조회 ==!
        getOrgzList: useFetch({
            api: () => APIS.getOrgzUsrRgsrLst(form.orgzListSrch.getValues()),
            onSuccess: (data) => {
                const orgzList = data["orgzList"].content;
                tree.setData(handler.createTreeData(orgzList));
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }),
            showToast: true,
        }),
    };

    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: () => {
            fetch.getOrgzList.fetch();
        },

        createTreeData: (orgList: any[]): Record<string, any>[] => {
            const tempList: Record<string, any>[] = orgList.map((item: any) => {
                return {
                    name: comnUtils.replaceEmpty(item.cstmOrgzNm),
                    checkbox: false,
                    cstmOrgzId: comnUtils.replaceEmpty(item.cstmOrgzId),
                    cstmOrgzNm: comnUtils.replaceEmpty(item.cstmOrgzNm),
                    orgzLvl: comnUtils.replaceEmpty(item.orgzLvl, 0),
                    uprCstmOrgzId: comnUtils.replaceEmpty(item.uprCstmOrgzId),
                    uprCstmOrgzNm: comnUtils.replaceEmpty(item.uprCstmOrgzNm),
                    cstmOrgzTpCd: comnUtils.replaceEmpty(item.cstmOrgzTpCd),
                    cstmOrgzCd: comnUtils.replaceEmpty(item.cstmOrgzCd),

                    children: [],
                };
            });

            const map: Record<string, any> = {};
            tempList.forEach((item: Record<string, any>) => {
                map[item.cstmOrgzId] = item;
            });

            const treeData: Record<string, any>[] = [];
            tempList.forEach((item: Record<string, any>) => {
                if (item.uprCstmOrgzId && map[item.uprCstmOrgzId]) {
                    const parentNode = map[item.uprCstmOrgzId];
                    parentNode.children.push(item);
                } else {
                    treeData.push(item);
                }
            });

            return treeData;
        },
        //Click Organizations List Tree !== 조직 트리 클릭 ==!
        onTreeClick: (treeInfo: any) => {
            form.orgzInfo.clearValues();
            form.orgzInfo.setValues(treeInfo);
        },
        //Click Aply Button !== 적용 버튼 클릭 ==!
        onBtnAplyClick: () => {
            let treeInfo = form.orgzInfo.getValue();

            if (treeInfo.cstmOrgzTpCd === "U") {
                modal.openModal({ content: "msg.ptl.00722" }); // You cannot add sub-organizations of Unit. !== Unit 의 하위조직은 추가할 수 없습니다. ==!
                return;
            }

            props?.callback?.({ code: treeInfo.cstmOrgzCd, label: treeInfo.cstmOrgzNm, rowData: treeInfo });

            modal.closeModal(props.id);
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        console.log("===params.cstmOrgzTpCd===" + params.cstmOrgzTpCd);

        form.orgzListSrch.setValue("cstmOrgzTpCd", params.cstmOrgzTpCd);
        handler.onSrchBtnClick();
        form.orgzInfo.setEditable(false);

        tree.tree._tree.current._checkbox = false;
    }, [theme.lang]);

    return (
        <Page title={t("T_ORGZ_USR_RGSR_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.orgzListSrch.schema.cstmOrgzNm} />
                            </Group.Row>
                        </Group.Section>
                        <Layout>
                            <Layout.Left>
                                <Button role={"reset"} onClick={() => form.orgzListSrch.reset()} />
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role={"search"}
                                    onClick={() => {
                                        handler.onSrchBtnClick();
                                    }}
                                />
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Layout gap={4}>
                <Group>
                    <Group.Header>
                        <Group.Title title={"T_ORGZ_LIST"} />
                    </Group.Header>
                    <Group.Body>
                        <Tree {...tree.tree} size={12} height={300} onClick={handler.onTreeClick} />
                    </Group.Body>
                </Group>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.orgzInfo.schema.uprCstmOrgzId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgzInfo.schema.cstmOrgzTpCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.orgzInfo.schema.cstmOrgzNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"apply"} onClick={handler.onBtnAplyClick} />
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </Layout>
        </Page>
    );
};
